import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { fetchLocateByCollection } from './actions'
import { ensureMeta } from '../../shared/actions/meta';
import Field from '../../shared/components/fields/Inputs';

// {host}/locate/by-collection/{collectionId}

class LocateByCollection extends Component {
    static propTypes = {
        greeting: PropTypes.string
    };

    state = {
        emailAddress: this.props.emailAddress,
        errors: []
    };

    componentWillMount() {
        this.props.dispatch(ensureMeta(this.props.match.params.collectionId))
    }

    handleOnSubmit = (e) => {
        e.preventDefault();
        let errors = this.input.validate(this.state.emailAddress);
        if (errors && errors.length > 0){
            this.setState({
                errors: errors
            });
        } else {
            this.props.dispatch(fetchLocateByCollection(this.props.match.params.collectionId, this.state.emailAddress));
        }
    }

    handleOnChange = (data) => {
        let errors = this.input.validate(data['emailAddress']);
        if (errors && errors.length > 0) {
            this.setState({
                'errors': errors
            });
            this.input.focus();
        } else {
            this.setState({
                errors: errors,
                emailAddress: data.emailAddress
            });
        }
    }

    componentDidMount() {
        if (this.input)
            this.input.focus();
    }

    emailFieldDef = {
        'key': 'emailAddress',
        'label': 'Email Address',
        'dataType': 'STRING',
        'defaultValue': '',
        'isRequired': true,
        'validators': [
            {
                'type': 'email',
                'errorMessage': 'Must be a valid email address'
            }
        ],
        'valueHint': 'yourname@company.com'
    };

    render() {
        if (this.props.authToken){
            var target = '/app/locate/by-token/' + this.props.match.params.collectionId + '/' + this.props.authToken;
            return <Redirect to={target} />
        } else {
            //const { match: { params: { recordDefinitionKey }}} = this.props;
            return (
                <div className="ac-wizard">
                    <div className="ac-wizard-header">
                        <h2>Welcome!</h2>
                    </div>
                    <div className="ac-wizard-body">
                        <p className="ac-pre">{this.props.greeting}</p>
                        <label>Please log in with your email address to begin</label>
                        <Field key="emailAddress"
                               value={this.state.emailAddress}
                               errors={this.state.errors}
                               fieldDef={this.emailFieldDef}
                               onValueChanged={this.handleOnChange}
                               ref={(me) => this.input = me} />
                    </div>
                    <div className="ac-wizard-nav">
                        <span>We will send you an email to confirm your email address</span>
                        <input type="button" className="ac-btn ac-btn-primary" value="Login" onClick={this.handleOnSubmit}/>
                    </div>
                </div>);
        }
    }
}

function mapStateToProps(state) {
    return {
        authToken: state.components.locate.authToken,
        description: state.meta ? state.meta.description : '',
        greeting: state.meta ? state.meta.preAuthWelcomeMessage : ''
    };
}

export default connect(mapStateToProps)(LocateByCollection);